import { Store } from '@ngxs/store';
import { ApplicationSelectors } from '@shared/storage/application/application.selectors';

export class LocaleId extends String {
  constructor(private readonly store: Store) {
    super();
  }

  public toString(): string {
    return this.store.selectSnapshot(ApplicationSelectors.language);
  }

  public valueOf(): string {
    return this.toString();
  }
}